import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.syncPressedState()
  }

  toggle(event) {
    if (event.target.closest("label, input, button, a")) return
    if (!this.hasInputTarget) return

    this.toggleInput()
  }

  keydown(event) {
    if (!["Enter", " "].includes(event.key)) return
    if (!this.hasInputTarget) return

    event.preventDefault()
    this.toggleInput()
  }

  toggleInput() {
    this.inputTarget.checked = !this.inputTarget.checked
    this.syncPressedState()
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  syncPressedState() {
    if (!this.hasInputTarget) return

    this.element.setAttribute("aria-pressed", this.inputTarget.checked ? "true" : "false")
  }
}
